import {
	memo, SVGProps,
} from 'react';

// eslint-disable-next-line react/display-name
export const IconChevronRight = memo<SVGProps<SVGSVGElement>>((props: SVGProps<SVGSVGElement>) => (
	<svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M16.7844 12.5343L10.0344 19.2843C9.89103 19.423 9.69942 19.5004 9.50001 19.5004C9.3006 19.5004 9.10899 19.423 8.96563 19.2843C8.8248 19.1422 8.74579 18.9501 8.74579 18.75C8.74579 18.5498 8.8248 18.3578 8.96563 18.2156C10.0823 17.1008 15 12 15 12C15 12 10.074 6.89081 8.96563 5.78435C8.84604 5.63862 8.78492 5.45363 8.79416 5.26534C8.80341 5.07705 8.88236 4.89893 9.01567 4.76563C9.14897 4.63233 9.32708 4.55338 9.51537 4.54413C9.70366 4.53488 9.88866 4.596 10.0344 4.7156L16.7844 11.4656C16.9252 11.6078 17.0042 11.7998 17.0042 12C17.0042 12.2001 16.9252 12.3922 16.7844 12.5343Z" fill={props.color} />
	</svg>
));
